// extracted by mini-css-extract-plugin
export default {"table":"request-table_table__gbl7B","tableCell":"request-table_tableCell__0BcCA","tableCellActive":"request-table_tableCellActive__iZcMn"};